export const UNCOMPLETED_MESSAGES_SET = "UNCOMPLETED_MESSAGES_SET";
export const UNCOMPLETED_MESSAGE_STATUS_CHANGE = "UNCOMPLETED_MESSAGE_STATUS_CHANGE";
export const UPDATE_UNCOMPLETED_MESSAGE = "UPDATE_UNCOMPLETED_MESSAGE";
export const DELETE_UNCOMPLETED_MESSAGE = "DELETE_UNCOMPLETED_MESSAGE";
export const ADD_UNCOMPLETED_MESSAGE = "ADD_UNCOMPLETED_MESSAGE";

